import * as UIKit from "~/src/modules/ui-kit";

import useBrand from "./useBrand";



export default function Brand(props) {
    const { children, id, ...restProps } = props;

    const brandQuery = useBrand(id);

    if (!id) return undefined;

    if (brandQuery.loading) return <UIKit.CardSkeleton />;
    if (brandQuery.error) return undefined;

    return (
        <UIKit.Card { ...restProps }>
            <UIKit.LetterBackdrop>B</UIKit.LetterBackdrop>
            <UIKit.CardFace2>
                <span className="fluid-accent">{ brandQuery.data.brand.name }</span>
                <span>{ brandQuery.data.brand.id }</span>
            </UIKit.CardFace2>
            { children }
        </UIKit.Card>
    );
}
